import dynamic from "next/dynamic";
import { ReactNode } from "react";

// Dynamically import TransitionGroup only on client side to avoid build issues
// Using 'as any' to avoid type checking during build
const TransitionGroup = dynamic(
  () =>
    import("react-transition-group").then((mod) => mod.TransitionGroup) as any,
  { ssr: false }
) as any;

type ClientTransitionGroupProps = {
  children: ReactNode;
  component?: React.ElementType | null;
  [key: string]: any; // Allow any other props
};

const ClientTransitionGroup = ({
  children,
  ...props
}: ClientTransitionGroupProps) => {
  // During SSR, render children without transition
  if (typeof window === "undefined") {
    return <>{children}</>;
  }

  return <TransitionGroup {...props}>{children}</TransitionGroup>;
};

export default ClientTransitionGroup;
